import React from 'react';
import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';
import Root from './components/RootProductPageMobile';
import configureStore from './store/productPageStore';
import getWebpackPublicPath from './utils/commonUtils';
import entryPointSetup from './refresh/utils/entryPointUtils';
// import PdpHeader from './refresh/organism/Header/pdp-header';
import './ajio-styles/root.pcss';
import 'regenerator-runtime/runtime';
import "./web-vitals-integration";
// import "./instrument.js";
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => import('./initializeCopilot'), { timeout: 5000 });
} else {
  setTimeout(() => import('./initializeCopilot'), 5000);
}

const preloadedState = window.__PRELOADED_STATE__;
__webpack_public_path__ = getWebpackPublicPath();

const { store, persistor } = configureStore(preloadedState);

if (window.pageType !== 'OFFLINEPAGE') {
  const container = document.getElementById('app');
  const root = createRoot(container);
  root.render(<Root store={store} persistor={persistor} />);
}

entryPointSetup();
